export default "/assets/Image/moment-card-placeholder-block.png"